import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Snowflake } from 'lucide-react';
import { AuthAPI } from '../api';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate('/login', { replace: true }); return; }
    const sid = decodeURIComponent(m[1]);

    (async () => {
      try {
        const res = await AuthAPI.session(sid);
        setUser(res.user);
        // Clean the fragment before landing
        window.history.replaceState(null, '', '/app');
        navigate('/app', { replace: true, state: { user: res.user } });
      } catch (e) {
        navigate('/login', { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="h-12 w-12 rounded-lg bg-gradient-to-br from-sky-500 to-cyan-500 flex items-center justify-center mx-auto mb-4">
          <Snowflake className="h-6 w-6 text-white animate-pulse" strokeWidth={2.5} />
        </div>
        <div className="text-slate-600">Signing you in</div>
      </div>
    </div>
  );
}
